import {
  selectActiveFiltersCount,
  selectFilters,
  setActiveFilters,
  setActiveFiltersCount,
  setOpenedFilter,
} from "features/Filters/filtersSlice";
import { ActiveFilter } from "features/Filters/types";
import { selectModalType } from "features/rootModal/rootModalSlice";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

export const useSelectFilters = (activeFilters: ActiveFilter[]) => {
  const dispatch = useDispatch();
  const activeFiltersCount = useSelector(selectActiveFiltersCount);
  const filters = useSelector(selectFilters);
  const modalType = useSelector(selectModalType);

  useEffect(() => {
    if (activeFilters.length > 0) {
      dispatch(setActiveFilters(activeFilters));
      dispatch(setActiveFiltersCount(activeFilters.length));
    }
  }, [activeFilters]);

  useEffect(() => {
    return () => {
      if (!modalType) {
        dispatch(setActiveFilters([]));
        dispatch(setActiveFiltersCount(0));
        dispatch(setOpenedFilter(""));
      }
    };
  }, []);

  return { filters, activeFiltersCount };
};
